export default function isModifiedEvent(event, preventDefaultEventKeys = []) {
  const props = ['metaKey', 'altKey', 'ctrlKey', 'shiftKey'].filter(
    (prop) => !preventDefaultEventKeys.includes(prop)
  );
  return props.some((prop) => !!event[prop]);
}
